import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { EmailTemplate } from "@redotech/redo-model/email-template";
import { SmsTemplate } from "@redotech/redo-model/sms-template";
import { createContext, ReactNode } from "react";

export interface AutomationContext {
  emailTemplates: EmailTemplate[];
  originEmailTemplates: EmailTemplate[];
  smsTemplates: SmsTemplate[];
}

export const AutomationContext = createContext<AutomationContext | null>(null);

export const AutomationContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const marketingRpcClient = useRequiredContext(RedoMarketingRpcClientContext);
  const emailTemplatesLoad = useLoad(
    async (signal) =>
      await marketingRpcClient.getEmailTemplates({}, { signal }),
    [marketingRpcClient],
  );
  const originEmailTemplatesLoad = useLoad(
    async (signal) =>
      await marketingRpcClient.getOriginEmailTemplates({}, { signal }),
    [marketingRpcClient],
  );
  const smsTemplatesLoad = useLoad(async () => {
    const templates = await marketingRpcClient.paginateSmsTemplates({
      page: 1,
      pageSize: 1000,
    });
    return templates.data;
  }, [marketingRpcClient]);

  return (
    <AutomationContext.Provider
      value={{
        emailTemplates: emailTemplatesLoad.value || [],
        originEmailTemplates: originEmailTemplatesLoad.value || [],
        smsTemplates: smsTemplatesLoad.value || [],
      }}
    >
      {children}
    </AutomationContext.Provider>
  );
};
